/* eslint-disable no-warning-comments */

import { SeatStatus } from 'types/Location'

export const COLORS = {
    notAvailable: '#000000',
    sold: '#F4C000',
    arrived: '#00830D',
    currentlyScanned: '#00ff19',
    alreadyUsed: '#CE0000',
}

// TODO: session storage - telefon lezárás ellen

export const SeatColors: Record<SeatStatus, string> = {
    [SeatStatus.NotAvailable]: COLORS.notAvailable,
    [SeatStatus.Complimentary]: COLORS.sold,
    [SeatStatus.Sold]: COLORS.sold,
    [SeatStatus.Arrived]: COLORS.arrived,
    [SeatStatus.Reserved]: COLORS.notAvailable,
    [SeatStatus.InPayment]: COLORS.notAvailable,
    [SeatStatus.Selected]: COLORS.notAvailable,
    [SeatStatus.Available]: COLORS.notAvailable,
}
